import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  setCookie(name: string, value: string, days: number = 1): void {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    
    document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))};${expires};path=/`;
  }

  getCookie(name: string): string | null {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.indexOf(nameEQ) === 0) {
        try {
          const encodedValue = cookie.substring(nameEQ.length);
          return JSON.parse(decodeURIComponent(encodedValue));
        } catch (e) {
          console.error('Cookie decode error:', e);
          return null;
        }
      }
    }
    return null;
  }

  deleteCookie(name: string): void {
    this.setCookie(name, '', -1);
  }

  getAllCookies(): { [key: string]: string } {
    const cookies: { [key: string]: string } = {};
    const cookiesArray = document.cookie.split(';');

    for (let cookie of cookiesArray) {
      const [name, ...valueParts] = cookie.split('=');
      if (name && valueParts.length > 0) {
        try {
          const value = JSON.parse(decodeURIComponent(valueParts.join('=').trim()));
          cookies[name.trim()] = value;
        } catch (e) {
          console.error('Cookie parse error:', e);
        }
      }
    }
    return cookies;
  }
}
